import React from 'react';
import { salesSubMenu } from './subMenus';
import TopNavPopup from './TopNavPopup';

const SalesPopup = () => {
  return <TopNavPopup name={'Sales'} subMenu={salesSubMenu} />;
};

export default SalesPopup;
